import { AcInputAttribute } from './ac-input-attribute-palette.class';
import { AcOutputAttributePalette } from './ac-output-attribute-palette.class';
export class AcPalette {
    _aid_: string;
    libraryName: string;
    libraryVersion: string;
    name: string;
    version: string;
    icon: string;
    label: string;
    category: string;
    config: {
        inputs: AcInputAttribute[];
        outputs: AcOutputAttributePalette[];
    };

    constructor(options: {
        libraryName: string;
        libraryVersion: string;
        name: string;
        version: string;
        icon: string;
        label: string;
        category: string;
        config: {
            inputs: AcInputAttribute[];
            outputs: AcOutputAttributePalette[];
        };
    }) {
        this._aid_ = window.crypto.randomUUID();
        this.libraryName = options.libraryName;
        this.libraryVersion = options.libraryVersion;
        this.name = options.name;
        this.version = options.version;
        this.icon = options.icon;
        this.label = options.label;
        this.category = options.category;
        this.config = options.config;
    }
}
